import type { MissionUiStatus } from '../constants/status'

export type MissionRewardScoreboard = {
  earnedPoints: number
  totalPoints: number
  earnedCoins: number
  totalCoins: number
}

type MissionRewardSource = {
  uiStatus: MissionUiStatus
  point_reward?: number | null
  coin_reward?: number | null
}

const sumRewards = (
  missions: MissionRewardSource[],
  predicate: (mission: MissionRewardSource) => boolean
) =>
  missions.reduce(
    (totals, mission) => {
      if (!predicate(mission)) return totals

      return {
        points: totals.points + (mission.point_reward ?? 0),
        coins: totals.coins + (mission.coin_reward ?? 0)
      }
    },
    { points: 0, coins: 0 }
  )

export const computeMissionRewardScoreboard = (
  missions: MissionRewardSource[]
): MissionRewardScoreboard => {
  const total = sumRewards(missions, () => true)
  const earned = sumRewards(missions, mission => mission.uiStatus === 'success')

  return {
    earnedPoints: earned.points,
    totalPoints: total.points,
    earnedCoins: earned.coins,
    totalCoins: total.coins
  }
}
